module.exports = "/_next/static/media/ebeacd512e171af9eadada46181ab991.svg";